import PropTypes from 'prop-types';
import "./StreamAnalyticsSummary.scss";
import { toast } from "react-toastify";
import axios from "../../api/axios";
import { convertMSToHMS, getLongDateString } from "../../helpers/Dates";
import { disableStreamSessionRoute } from "../../api/routes";
import { TwitchIconSvg } from '../../assets/assets';
import HeadedPanel from '../HeadedPanel/HeadedPanel';
import { IconJsxer } from '../../helpers/IconHelper';
import Toggle from '../forms/Toggle/Toggle';
import { parseTimezone } from '../../helpers/TimeZones';
import CirclePerc from '../CirclePerc/CirclePerc';
import LeftColorBlockBox from '../LeftColorBlockBox/LeftColorBlockBox';
/*
    If you want to restyle this, override the css!
*/
const StreamAnalyticsSummary = (props) => {

    const disableSessionAnalytics = (e, featureStartTime) => {
        e.preventDefault();
        axios
            .post(disableStreamSessionRoute, {
                campaignID: props._campaignID,
                featureStartTime: featureStartTime,
                withCredentials: true
            })
            .then(function (response) {
                props._setCampaignDataFunc(response.data.analyticsData.streams);
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
            });
    };

    let dataObj = {
        peakViewers: 0,
        totalMessages: 0,
        totalInteractions: 0,
        uniqueInteractionUsers: 0,
        uniqueUsers: 0,
        engagementTime: 0,
        totalRunTime: 0,
        featuresRun: 0,
        botsPosted: 0,
        disruptorsPlayed: 0,
        totalTargetTime: 0,
        streamData: []
    };

    props._campaignAnalyticsSummary.forEach((campaignSummary) => {
        if (campaignSummary.streamID == props._streamID) {
            campaignSummary.recordedAnalytics.forEach((individualStreamData) => {
                if (!individualStreamData.disabled) {
                    if (individualStreamData.peakViewers > dataObj.peakViewers) {
                        dataObj.peakViewers = individualStreamData.peakViewers;
                    }
                    dataObj.totalMessages += individualStreamData.messages;
                    dataObj.totalRunTime += individualStreamData.featureRunTime;
                    dataObj.totalTargetTime += props._endTime - props._startTime;
                    dataObj.uniqueUsers += individualStreamData.uniqueUsers;
                    dataObj.totalInteractions += individualStreamData.interactions;
                    dataObj.uniqueInteractionUsers += individualStreamData.uniqueInteractionUsers;
                    dataObj.engagementTime += individualStreamData.engagementTime;
                    dataObj.featuresRun += individualStreamData.featuresRun;
                    dataObj.botsPosted += individualStreamData.botsPosted;
                    dataObj.disruptorsPlayed += individualStreamData.disruptorsFired;
                }
                dataObj.streamData.push(individualStreamData);
            });
        }
    });

    const timezoneData = parseTimezone(props._timeZone);
    const startTimeStr = convertMSToHMS(props._startTime, false, timezoneData.offset);
    const endTimeStr = convertMSToHMS(props._endTime, false, timezoneData.offset);
    const engagementTimeStr = convertMSToHMS(dataObj.engagementTime);
    const totalRunTimeStr = convertMSToHMS(dataObj.totalRunTime);

    const targetTimePerc = dataObj.totalTargetTime > 0
        ? (dataObj.totalRunTime / dataObj.totalTargetTime) * 100
        : 0;

    return (
        <>
            {dataObj.streamData.length > 0 && (
                <div className='no-panel-shadow'>
                    <HeadedPanel
                        color="an-stream-summary"
                        className="tight"
                        headingContent={
                            <div className="an-stream-header">
                                <div className="an-stream-header-top">
                                    <div className="fl-row an-stream-title-row">
                                        <div className="stream-twitch-logo">
                                            {TwitchIconSvg}
                                        </div>
                                        <div className="an-stream-title-text">
                                            {props._streamName || props._twitchHandle}
                                        </div>
                                        <div className="an-stream-channels">
                                            {props._channels && props._channels.length > 0 && (
                                                <div className="sa-channel-icons-wrapper">
                                                    <div className="sa-channel-icons">
                                                        {props._channels.slice(0, 2).map((channel, idx) => (
                                                            <div key={idx} className="sa-channel-icon">
                                                                {channel.profilePic ? (
                                                                    <img src={channel.profilePic} alt={channel.twitchHandle} className="sa-channel-avatar" />
                                                                ) : (
                                                                    <div className="sa-channel-avatar"></div>
                                                                )}
                                                            </div>
                                                        ))}
                                                        {props._channels.length > 2 && (
                                                            <div className="sa-channel-icon sa-additional-count">
                                                                +{props._channels.length - 2}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="an-stream-header-bottom">
                                    <div className='fl-row sa-time compact'>
                                        <div>{IconJsxer.GetIcon(IconJsxer.ICONS.scheduleNav, IconJsxer.ICON_STYLES.standardW)}</div>
                                        <div className="time">{getLongDateString(props._startTime)}</div>
                                    </div>
                                    <div className='fl-row sa-time compact'>
                                        <div>{IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.standardW)}</div>
                                        <div className="time">
                                            {`${startTimeStr.h_str}:${startTimeStr.m_str} - ${endTimeStr.h_str}:${endTimeStr.m_str} (${timezoneData.label.replace('(', '').replace(')', '')})`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    >
                        <div className='fl-column an-stream-summary-holder'>
                            <div className='fl-row'>
                                <div className='fl-column fl-start'>
                                    <div className='fl-row'>
                                        <CirclePerc perc={targetTimePerc < 100 ? targetTimePerc : 100}>
                                            {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.streamControlOptions)}
                                        </CirclePerc>
                                        <div className="fl-column compact">
                                            <h3>{`${totalRunTimeStr.h}h ${totalRunTimeStr.m_str}m ${totalRunTimeStr.s_str}s`}</h3>
                                            <h4 className='light-text'>Total Run Time</h4>
                                        </div>
                                    </div>
                                    <div className='fl-row compact'>
                                        <div>{IconJsxer.GetIcon(IconJsxer.ICONS.eye, IconJsxer.ICON_STYLES.standardW)}</div>
                                        <div>Peak Viewers: {dataObj.peakViewers.toLocaleString()}</div>
                                    </div>
                                </div>
                                <div className='stream-metrics-grid'>
                                    <LeftColorBlockBox style="an_brand_engagement">
                                        <div className='analytics-summary-content'>
                                            <div>Feature Engagement</div>
                                            <h5>{engagementTimeStr.h+':'+engagementTimeStr.m_str+':'+engagementTimeStr.s_str}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                    <LeftColorBlockBox style="an_total_interactions">
                                        <div className='analytics-summary-content'>
                                            <div>Total Interactions</div>
                                            <h5>{dataObj.totalInteractions.toLocaleString()}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                    <LeftColorBlockBox style="an_u_users">
                                        <div className='analytics-summary-content'>
                                            <div>Unique Users</div>
                                            <h5>{dataObj.uniqueUsers.toLocaleString()}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                    <LeftColorBlockBox style="an_messages">
                                        <div className='analytics-summary-content'>
                                            <div>Messages</div>
                                            <h5>{dataObj.totalMessages.toLocaleString()}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                    <LeftColorBlockBox style="feature_default">
                                        <div className='analytics-summary-content'>
                                            <div>Features Ran</div>
                                            <h5>{dataObj.featuresRun}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                    <LeftColorBlockBox style="disruptor_default">
                                        <div className='analytics-summary-content'>
                                            <div>Disruptors Started</div>
                                            <h5>{dataObj.disruptorsPlayed}</h5>
                                        </div>
                                    </LeftColorBlockBox>
                                </div>
                            </div>
                            <hr></hr>
                            <div className='fl-row grow'>
                                <div className='fl-column grow'>
                                    <h4>Recorded Sessions</h4>
                                    {dataObj.streamData.map((val, index) => {
                                        const featureRunTimeStr = convertMSToHMS(val.featureRunTime);
                                        return (
                                            <div className={`an-session-list-item ${index % 2 === 1 ? 'an-session-dark' : 'an-session-light'}`} key={'sess_' + index}>
                                                <div className='fl-column compact grow'>
                                                    <h5>
                                                        {index + 1}. {getLongDateString(val.featureStartTime)} ({featureRunTimeStr.h}:{featureRunTimeStr.m_str}:{featureRunTimeStr.s_str})
                                                    </h5>
                                                    <div className='fl-row session-metrics-row'>
                                                        <div className='fl-row compact session-metric'>
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.clock, IconJsxer.ICON_STYLES.standardW)}
                                                            <span className='stat-text'>
                                                                Stream Time: {featureRunTimeStr.h}:{featureRunTimeStr.m_str}:{featureRunTimeStr.s_str}
                                                            </span>
                                                        </div>
                                                        <div className='fl-row compact session-metric'>
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.eye, IconJsxer.ICON_STYLES.standardW)}
                                                            <span className='stat-text'>Peak Viewers: {val.peakViewers.toLocaleString()}</span>
                                                        </div>
                                                        <div className='fl-row compact session-metric'>
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.hashtag, IconJsxer.ICON_STYLES.standardW)}
                                                            <span className='stat-text'>Interactions: {val.interactions.toLocaleString()}</span>
                                                        </div>
                                                        <div className='fl-row compact session-metric'>
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.commentDots, IconJsxer.ICON_STYLES.standard)}
                                                            <span className='stat-text'>Messages: {val.messages.toLocaleString()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='grow'></div>
                                                <div className='fl-column shrink session-actions'>
                                                    <div className='fl-row grow'>
                                                        <div className='grow'></div>
                                                        <div className='fl-row shrink'>
                                                            <span className='toggle-label'>Include</span>
                                                            <Toggle
                                                                id={'sess_togg_' + index}
                                                                currentState={!val.disabled}
                                                                toggleFunc={(e) => { disableSessionAnalytics(e, val.featureStartTime) }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <button className='standard-button' onClick={(e) => { e.preventDefault(); props._openSessionAnalytics(val, props._twitchHandle, props._streamID) }}>View Details</button>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </HeadedPanel>
                </div>
            )}
        </>
    );
}

export default StreamAnalyticsSummary;